import PropTypes from 'prop-types';
import IconSvg from 'Components/IconSvg';

const SupportTicket = ({
  createdAt,
  createdAtDisplay,
  description,
  id,
  isRead,
  locale,
  status,
  subject,
  token,
  type,
  updatedAt,
  updatedAtDisplay,
  url,
}) => {
  return (
    <a
      className={`support-ticket ${isRead ? '' : 'support-ticket--unread'}`}
      href={url}
    >
      <div className="support-ticket__wrapper">
        <p className="support-ticket__tag">Support</p>
        <div className="support-ticket__id">
          {!isRead && <div className="support-ticket__id-notification"></div>}
          <span>{`Ticket #${id}`}</span>
        </div>
        <p className="support-ticket__meta">
          {updatedAtDisplay}
          <IconSvg type="arrowRight" />
        </p>
        <p className="support-ticket__subject">{subject}</p>
      </div>
    </a>
  );
};

SupportTicket.propTypes = {
  createdAt: PropTypes.string.isRequired,
  createdAtDisplay: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  updatedAtDisplay: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

SupportTicket.defaultProps = {
  isRead: true,
};

export default SupportTicket;
